import { ChargeStatus } from '@40seas/entities/charges';
import { PaymentMethodProviderType } from '@40seas/entities/payment-methods';
import { z } from 'zod';
import { EnumSchema, FromSchema } from '@40seas/entities/common';
import { Currency } from '@40seas/models';

export const ChargeReconciliationSchema = z
    .object({
        id: z.string().regex(/^[0-9a-f]{24}$/i),
        buyerLegalName: z.string(),
        supplierLegalName: z.string(),
        amount: z.number(),
        currency: EnumSchema(Currency).nullish(),
        status: EnumSchema(ChargeStatus),
        completionDate: z.date(),
        provider: EnumSchema(PaymentMethodProviderType),
        revenue: z.number().optional(),
        invoice: z
            .string()
            .regex(/^[0-9a-f]{24}$/i)
            .optional(),
        checkout: z
            .string()
            .regex(/^[0-9a-f]{24}$/i)
            .optional(),
    })
    .strict();

export class ChargeReconciliation extends FromSchema(ChargeReconciliationSchema) {
    id: string;
    buyerLegalName: string;
    supplierLegalName: string;
    amount: number;
    status: ChargeStatus;
    completionDate: Date;
    provider: PaymentMethodProviderType;
    currency: Currency;
    revenue: number;
    invoice: string;
    checkout: string;
}
